import * as React from "react";
import { ChatContextProps, ChatUIStage } from "../types";

const ChatContext = React.createContext<ChatContextProps | null>({
  chatStage: ChatUIStage.Loading,
  setChatStage: null,
  closedByAgent: false,
  setClosedByAgent: null
});

export default ChatContext;
